import React, { useState } from 'react';
import '../../styles/SiteNode.css';

const CircuitNode = () => {
  const [rackData, setRackData] = useState({
    rackCount: '',
    rackID: '',
    rackType: '',
    manufacturer: '',
    rackHeight: '',
    usedSpace: '',
    availableSpace: '',
    status: '',
    weightCapacity: '',
    rackUtilization: '',
    shelfNumber: '',
    installedEquipment: '',
    heightInUs: '',
    height: '',
    widthBetweenHoles: '',
    assetNumber: '',
    serialNumber: '',
    location: '',
    building: '',
    room: '',
    productManufacturer: '',
    productNumber: '',
    partNumber: '',
    productDescription: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRackData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(rackData);
    // Add submission logic here
  };

  return (
    <form className="rack-form create-site-form" onSubmit={handleSubmit}>
      <h2>Rack Form</h2>

      <div className="form-group">
        <label>Rack Count</label>
        <input
          type="text"
          name="rackCount"
          value={rackData.rackCount}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Rack ID</label>
        <input
          type="text"
          name="rackID"
          value={rackData.rackID}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Rack Type</label>
        <input
          type="text"
          name="rackType"
          value={rackData.rackType}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Manufacturer</label>
        <input
          type="text"
          name="manufacturer"
          value={rackData.manufacturer}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Rack Height (U)</label>
        <input
          type="text"
          name="rackHeight"
          value={rackData.rackHeight}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Used Space (U)</label>
        <input
          type="text"
          name="usedSpace"
          value={rackData.usedSpace}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Available Space (U)</label>
        <input
          type="text"
          name="availableSpace"
          value={rackData.availableSpace}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Status</label>
        <input
          type="text"
          name="status"
          value={rackData.status}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Weight Capacity (kg)</label>
        <input
          type="text"
          name="weightCapacity"
          value={rackData.weightCapacity}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Rack Utilization</label>
        <input
          type="text"
          name="rackUtilization"
          value={rackData.rackUtilization}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Shelf Number</label>
        <input
          type="text"
          name="shelfNumber"
          value={rackData.shelfNumber}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Installed Equipment</label>
        <input
          type="text"
          name="installedEquipment"
          value={rackData.installedEquipment}
          onChange={handleChange}
        />
      </div>

      <h3>Rack Details</h3>

      <div className="form-group">
        <label>Height in U's</label>
        <input
          type="text"
          name="heightInUs"
          value={rackData.heightInUs}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Height</label>
        <input
          type="text"
          name="height"
          value={rackData.height}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Width Between Holes</label>
        <input
          type="text"
          name="widthBetweenHoles"
          value={rackData.widthBetweenHoles}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Asset Number</label>
        <input
          type="text"
          name="assetNumber"
          value={rackData.assetNumber}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Serial Number</label>
        <input
          type="text"
          name="serialNumber"
          value={rackData.serialNumber}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Location</label>
        <input
          type="text"
          name="location"
          value={rackData.location}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Building</label>
        <input
          type="text"
          name="building"
          value={rackData.building}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Room</label>
        <input
          type="text"
          name="room"
          value={rackData.room}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Product Manufacturer</label>
        <input
          type="text"
          name="productManufacturer"
          value={rackData.productManufacturer}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Product Number</label>
        <input
          type="text"
          name="productNumber"
          value={rackData.productNumber}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Part Number</label>
        <input
          type="text"
          name="partNumber"
          value={rackData.partNumber}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Product Description</label>
        <input
          type="text"
          name="productDescription"
          value={rackData.productDescription}
          onChange={handleChange}
        />
      </div>

      <div className="form-actions">
        <button type="button" className="cancel-button">
          Cancel
        </button>
        <button type="submit" className="submit-button">
          Save Rack
        </button>
      </div>
    </form>
  );
};

export default CircuitNode;
